import { HeaderMenuLink } from '@monorepo/types';
import { useQuery } from '@tanstack/react-query';
import { fetchHeaderMenu } from '../../utils/react-query/query-functions';
import { QUERY_KEYS } from '../../utils/react-query/query-keys';
import { ExtractFnReturnType } from '../../utils/react-query/react-query';

export const useHeaderMenuLinks = () => {
  return useQuery<
    ExtractFnReturnType<typeof fetchHeaderMenu>,
    Error,
    HeaderMenuLink[]
  >({
    queryKey: QUERY_KEYS.APP_CONFIG.HEADER_MENU,
    queryFn: fetchHeaderMenu,
    staleTime: 60 * 60 * 1000,
    refetchInterval: 60 * 60 * 1000,
    refetchOnMount: true,
    refetchOnReconnect: true,
    refetchOnWindowFocus: false,
  });
};
